import React from 'react';

import { Loader } from '.';
import {withParamsFrame} from "../HOCs";
import {IframePage} from "../types/iframe";

const DasboardAdmin: React.FC<IframePage> = ({ params }) => {
    const [httpParams] = React.useState(params);
    const [loaded, setLoaded] = React.useState(false);

    return (
        <>
            <div className='xs:mx-3'>
                <iframe className={`${!loaded ? 'min-h-[auto]' : 'page-iframe-min'}`} src={`https://lk.market/dashboard${httpParams}`}
                    title="DasboardAdmin"
                    width="100%"
                    height={`${loaded ? "calc(100vh-64px)" : "0px"}`}

                    onLoad={() => setLoaded(true)}
                ></iframe>
            </div>
            {
                !loaded && <Loader />
            }
        </>
    );
};

export default withParamsFrame(DasboardAdmin);
